import React, { ChangeEvent, FormEvent } from 'react';
import { Typography, makeStyles, TextField, Grid, Button, InputLabel, Theme } from '@material-ui/core';
import { useAppState } from '../../../state';
import useVideoContext from '../../../hooks/useVideoContext/useVideoContext';
import { clearFirestoreUsersForCurrentPage, getProfileRedirectUrl } from '../../../utils/videoCallFirestore';

const useStyles = makeStyles((theme: Theme) => ({
  gutterBottom: {
    marginBottom: '1em',
  },
  inputContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '1.5em 0 3.5em',
    '& div:not(:last-child)': {
      marginRight: '1em',
    },
    [theme.breakpoints.down('sm')]: {
      margin: '1.5em 0 2em',
    },
  },
  textFieldContainer: {
    width: '100%',
    '& .MuiOutlinedInput-root': {
      
      '&.Mui-focused fieldset': {
        borderColor: '#FF3AD8',
      },
    },
  },
  continueButton: {
    backgroundColor: '#dfff00',
    color: '#000000',
    transition: 'background 0.3s, color 0.3s',
    border: 'none',
    borderRadius: '0px',
    '&:hover': {
      backgroundColor: '#000000',
      color: '#FFFFFF',
    },
    '&:disabled': {
      backgroundColor: '#e0e0e0',
      color: '#9e9e9e',
      cursor: 'not-allowed',
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
}));

interface RoomNameScreenProps {
  name: string;
  roomName: string;
  setName: (name: string) => void;
  setRoomName: (roomName: string) => void;
  handleSubmit: (event: FormEvent<HTMLFormElement>) => void;
}

export default function RoomNameScreen({ name, roomName, setName, setRoomName, handleSubmit }: RoomNameScreenProps) {
  const classes = useStyles();
  const { user } = useAppState();

  const { room } = useVideoContext();

  const onDisconnect = async () => {
    try {
      await clearFirestoreUsersForCurrentPage();
    } catch (error) {
      console.error('Leave (room name) Firestore:', error);
    }
    try {
      room?.disconnect();
    } catch (e) {
      console.error(e);
    }
    window.location.replace(getProfileRedirectUrl());
  };
  const handleNameChange = (event: ChangeEvent<HTMLInputElement>) => {
    setName(event.target.value);
  };

  const hasUsername = !window.location.search.includes('customIdentity=true') && user?.displayName;

  return (
    <>
      <Typography variant="h5" className={classes.gutterBottom}>
        Join a Room
      </Typography>
      <Typography variant="body1">
        {hasUsername
          ? "Enter the name of a room you'd like to join."
          : "Enter your name and the name of a room you'd like to join"}
      </Typography>
      <form onSubmit={handleSubmit}>
        <div className={classes.inputContainer}>
          {!hasUsername && (
            <div className={classes.textFieldContainer}>
              <InputLabel shrink htmlFor="input-user-name">
                Your Name
              </InputLabel>
              <TextField
                id="input-user-name"
                variant="outlined"
                fullWidth
                size="small"
                value={name}
                onChange={handleNameChange}
              />
            </div>
          )}
        </div>
        <Grid container justifyContent="flex-end" spacing={1}>
          <Grid item>
            <Button
              variant="contained"
              type="button"
              onClick={() => onDisconnect()}
              className={classes.continueButton}
              style={{
                backgroundColor: '#000000',
                color: '#FFFFFF',
                transition: 'background 0.3s, color 0.3s',
                border: 'none',
                borderRadius: '0px',
              }}
              onMouseOver={e => {
                (e.currentTarget as HTMLButtonElement).style.backgroundColor = '#dfff00';
                (e.currentTarget as HTMLButtonElement).style.color = '#000000';
              }}
              onMouseOut={e => {
                (e.currentTarget as HTMLButtonElement).style.backgroundColor = '#000000';
                (e.currentTarget as HTMLButtonElement).style.color = '#FFFFFF';
              }}
            >
              Go back
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              type="submit"
              disabled={!name || !roomName}
              className={classes.continueButton}
            >
              Continue
            </Button>
          </Grid>
        </Grid>
      </form>
    </>
  );
}
